import { Avatar, Box, FormControl, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import apiSlice from "../app/api/apiSlice";
import { lngs } from "../constants";

export const LangSwitcher = () => {
	const dispatch = useDispatch();
	const { i18n } = useTranslation();
	const currentLang = i18n?.language || "pl";
	const [lang, setLang] = useState(currentLang);

	const handleChange = (event) => {
		const selectedLang = event.target.value;
		setLang(selectedLang);
		i18n.changeLanguage(selectedLang);

		setTimeout(() => {
			dispatch(apiSlice.util.resetApiState());
			setTimeout(() => {
				dispatch(apiSlice.endpoints.getCurrentBranding.initiate());
				dispatch(apiSlice.endpoints.getSettingsJSON.initiate());
			}, 300);
		}, 700);
	};

	return (
		<Box
			sx={{
				backgroundColor: "#f2f2f2",
				p: "8px 4px 4px 4px",
				borderRadius: "2px",
			}}
		>
			<FormControl variant="standard" size="small">
				<Select
					labelId="language-select-label"
					value={lang}
					onChange={handleChange}
					sx={{ minWidth: 120, pb: 0 }}
				>
					{Object.entries(lngs).map(([code, { nativeName, flagUrl }]) => (
						<MenuItem key={code} value={code}>
							<Box display="flex" alignItems="center">
								<Avatar
									src={flagUrl}
									alt={nativeName}
									sx={{ width: 18, height: 18, marginRight: 1 }}
								/>
								{nativeName}
							</Box>
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
};
